import { render, staticRenderFns } from "./ResumoAtendentes.vue?vue&type=template&id=8773c080"
import script from "./ResumoAtendentes.vue?vue&type=script&lang=js"
export * from "./ResumoAtendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports